import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=94e0d5d2&scoped=true"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e0d5d2",
  null
  
)

export default component.exports